module.exports = __webpack_public_path__ + "static/blog-background-8f79f56887efb18a996ccb8b7ecab129.jpg";